<!--
 * @Author: xiaokun
 * @Date: 2020-02-27 13:41:53
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-11 14:30:57
 * @Description: 编辑/新建 问题库以及常用语时，对关键词/商品标签的新增/
 -->

<template>
  <mk-select
    :value="value"
    :multiple="multiple"
    filterable
    clearable
    :placeholder="placeholder"
    :width="width"
    popper-class="speech-storehouse-muti-select"
    @change="onSelect"
    @visible-change="onVisibleChange"
  >
    <mk-option
      v-for="(item, index) in optionsData"
      :key="item._id"
      :label="item[optionsProp.label]"
      :value="item[optionsProp.value]"
      :disabled="item.disabled"
    >
      <div
        v-if="index === 0 && showOptions"
        class="select-new-input"
      >
        <div
          v-if="showInput"
          class="add-new-input"
        >
          <mk-input
            v-model="inputNewVal"
            :maxlength="maxlength"
            show-word-limit
            height="22"
            class="input"
          ></mk-input>
          <span>
            <span
              class="cancel"
              @click="cancel"
            >取消</span>
            <span
              class="save"
              @click="confirmAdd"
            >确定</span>
          </span>
        </div>
        <div
          v-else
          class="add-new"
        >
          <span @click="addNew">新增</span>
        </div>
      </div>
    </mk-option>
  </mk-select>
</template>

<script>
export default {
  name: 'MutiSelect',
  model: { event: 'change', prop: 'value' },
  props: {
    value: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    optionsProp: {
      type: Object,
      default () {
        return {
          label: 'name',
          value: 'name'
        }
      }
    },
    optionsData: {
      type: Array,
      default: () => {
        return []
      }
    },
    width: {
      type: String,
      default: '420'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 是否为多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 输入框字符限制数
    maxlength: {
      type: [String, Number],
      default: '6'
    },
    // 是否展示操作栏
    showOptions: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      inputNewVal: '',
      // 是否展示新增框
      showInput: false
    }
  },
  methods: {
    onSelect (val) {
      this.$emit('change', val)
    },
    // 取消添加
    cancel () {
      this.inputNewVal = ''
      this.showInput = false
    },
    onVisibleChange () {
      this.cancel()
    },
    addNew () {
      this.showInput = true
    },
    confirmAdd () {
      if (!this.inputNewVal) return
      this.$emit('on-add-option', this.inputNewVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select-dropdown__item {
  height: 38px;
  line-height: 38px;
}

.el-select-dropdown__item.is-disabled {
  cursor: default;
}

.add-new-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #a1a1a1;
  font-size: 13px;

  .input {
    margin-right: 15px;
    flex: 1;
  }

  .cancel,
  .save {
    cursor: pointer;
  }

  .save {
    margin-left: 15px;
    color: #009cff;
  }
}

.add-new {
  text-align: right;
  font-size: 13px;
  color: #009cff;
  cursor: pointer;
}
</style>

<style lang="scss">
.speech-storehouse-muti-select {
  .el-select-dropdown__list {
    padding-top: 0;

    .el-select-dropdown__item {
      padding: 0 10px;
    }
  }
}
</style>
